module.exports = __webpack_public_path__ + "static/moura-dubeux-5fe397cd4ff4f4e218f71ab59cec3ffe.png";